import produce from "immer";
import {
  ADD_FEATURED,
  ADD_FEATURED_ERROR,
  ADD_FEATURED_SUCCESS,
  EDIT_FEATURED,
  EDIT_FEATURED_SUCCESS,
  EDIT_FEATURED_ERROR,
  DELETE_FEATURED,
  DELETE_FEATURED_ERROR,
  DELETE_FEATURED_SUCCESS,
  GET_FEATURED_LIST,
  GET_FEATURED_LIST_ERROR,
  GET_FEATURED_LIST_SUCCESS,
  DRAG_AND_DROP_PRODUCT,
} from "./actionTypes";

const initialState = {
  allFeaturedList: [],
  product: null,
  loading: false,
  error: "",
  totalPages: 0,
  limit: "",
  page: 1,
  sortOrder: "",
  sortField: "",
  search: "",
  addFeaturedLoad: false,
  deleteFeaturedLoad: false,
};

const challengesReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DRAG_AND_DROP_PRODUCT:
      return {
        ...state,
        allFeaturedList: payload,
      };
    case GET_FEATURED_LIST:
      return {
        ...state,
        loading: true,
      };

    //set Challenges list
    case GET_FEATURED_LIST_SUCCESS:
      return {
        ...state,
        allFeaturedList: payload,
        loading: false,
      };
    case GET_FEATURED_LIST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    // Add featured
    case ADD_FEATURED:
      return {
        ...state,
        addFeaturedLoad: true,
      };
    case ADD_FEATURED_SUCCESS:
      return {
        ...state,
        addFeaturedLoad: false,
      };
    case ADD_FEATURED_ERROR:
      return {
        ...state,
        addFeaturedLoad: false,
      };

    // Edit Featured
    case EDIT_FEATURED:
      return {
        ...state,
        addFeaturedLoad: true,
      };
    case EDIT_FEATURED_SUCCESS:
      return {
        ...state,
        addFeaturedLoad: false,
      };
    case EDIT_FEATURED_ERROR:
      return {
        ...state,
        addFeaturedLoad: false,
      };

    //delete
    case DELETE_FEATURED:
      return {
        ...state,
        deleteFeaturedLoad: true,
      };
    case DELETE_FEATURED_SUCCESS:
      return {
        ...state,
        deleteFeaturedLoad: false,
      };
    case DELETE_FEATURED_ERROR:
      return {
        ...state,
        deleteFeaturedLoad: false,
      };
    default:
      return state;
  }
});

export default challengesReducer;
